module.exports = __webpack_public_path__ + "assets/img/page1-side-nav-neutral-e193d231.png";